import { setQueryCookie } from '@/lib/cookie-helpers';


export default function ({ route }) {
  const query = route?.query;
  setQueryCookie(query);
}
